<script setup lang="ts">
defineProps<{
  termMonths: number
  monthlyPayment: number
}>()

defineEmits<{
  (e: 'select'): void
}>()

function pluralMonths(n: number): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return 'месяц'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'месяца'
  return 'месяцев'
}

function formatRub(value: number): string {
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 0 }).format(value)
}
</script>

<template>
  <div class="partner-term-card" @click="$emit('select')">
    <div class="partner-term-card__term">{{ termMonths }} {{ pluralMonths(termMonths) }}</div>

    <div class="partner-term-card__payment">
      <div class="partner-term-card__amount">от {{ formatRub(monthlyPayment) }} руб</div>
      <div class="partner-term-card__caption">Платеж в месяц</div>
    </div>

    <button type="button" class="partner-term-card__button" @click.stop="$emit('select')">Выбрать</button>
  </div>
</template>

<style lang="scss" scoped>
.partner-term-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  border: 1px solid #e6e8eb;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: #b3b8bf;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  }

  &__term {
    flex: 0 0 40%;
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  &__payment {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__amount {
    font-size: 16px;
    font-weight: 600;
    color: #1a1a1a;
  }

  &__caption {
    font-size: 12px;
    color: #6b7280;
  }

  &__button {
    flex: 0 0 auto;
    padding: 8px 18px;
    border: 1px solid #e6e8eb;
    border-radius: 10px;
    background: #fff;
    font-size: 14px;
    cursor: pointer;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;

    &__term {
      flex-basis: 100%;
    }
  }
}
</style>
